/** CompareMode — scenario comparison. Thin wrapper over the existing ComparePanel. */

import React from 'react';
import ComparePanel from '../ComparePanel';
import { useWorkspace } from './WorkspaceContext';

export default function CompareMode() {
  const { project, analysisResults, handleRunAll, handleSaveComparison } = useWorkspace();

  return (
    <ComparePanel
      project={project}
      analysisResults={analysisResults}
      onRunAll={handleRunAll}
      onSaveComparison={handleSaveComparison}
    />
  );
}
